export default __webpack_public_path__ + "static/estimate-7e3b1ff12151bf9f1f516ef22a6e7bf1.png";